import { configureStore } from '@reduxjs/toolkit';
import { loadStateFromSession, saveStateWithTimestamp, isStateStale } from '../utils/statePersistence';
// Temporary: add dummy auth reducer to avoid crashes until all components migrate
import authReducer from '../features/auth/dummyAuthSlice';
import productReducer from '../features/products/productSlice';
import storeReducer from '../features/store/storeSlice';
import cartReducer from '../features/cart/cartSlice';
import abandonedReducer from '../features/abandoned/abandonedSlice';
import ordersReducer from '../features/orders/ordersSlice';
import customersReducer from '../features/customers/customersSlice';
import analyticsReducer from '../features/analytics/analyticsSlice';
// import monthlyReducer from '../features/analytics/monthlySlice'; // Disabled - endpoint doesn't exist
import visitReducer from '../features/visits/visitSlice';
import discountsReducer from '../features/discounts/discountsSlice';
import expensesReducer from '../features/expenses/expensesSlice';
import teamReducer from '../features/team/teamSlice';
import rolesReducer from '../features/roles/rolesSlice';
import permissionsReducer from '../features/roles/permissionsSlice';
import delegationsReducer from '../features/team/delegationsSlice';
import onboardingReducer from '../features/onboarding/onboardingSlice';
import profileReducer from '../features/profile/profileSlice';
import mediaReducer from '../features/media/mediaSlice';
import appointmentReducer from '../features/appointments/appointmentSlice';
import pageReducer from '../features/pages/pageSlice';
import campaignsReducer from '../features/campaigns/campaignsSlice';
import customerReducer from '../features/customer/customerSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import transactionsReducer from '../features/transactions/transactionsSlice';
import customerGroupsReducer from '../features/customerGroups/customerGroupsSlice';
import settlementsReducer from '../features/settlements/settlementsSlice';
import collectionsReducer from '../features/collections/collectionsSlice';
import categoriesReducer from '../features/categories/categoriesSlice';

// Load persisted state if available and not stale
const persistedState = !isStateStale() ? loadStateFromSession() : undefined;

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    store: storeReducer,
    cart: cartReducer,
    abandoned: abandonedReducer,
    orders: ordersReducer,
    customers: customersReducer,
    analytics: analyticsReducer,
    // monthly: monthlyReducer, // Disabled - endpoint doesn't exist
    visits: visitReducer,
    discounts: discountsReducer,
    expenses: expensesReducer,
    team: teamReducer,
    roles: rolesReducer,
    permissions: permissionsReducer,
    delegations: delegationsReducer,
    onboarding: onboardingReducer,
    profile: profileReducer,
    media: mediaReducer,
    appointments: appointmentReducer,
    pages: pageReducer,
    campaigns: campaignsReducer,
    customer: customerReducer,
    notifications: notificationsReducer,
    transactions: transactionsReducer,
    customerGroups: customerGroupsReducer,
    settlements: settlementsReducer,
    collections: collectionsReducer,
    categories: categoriesReducer,
  },
  preloadedState: persistedState,
});

// Subscribe to store changes to persist state
if (typeof window !== 'undefined') {
  let timeoutId;
  store.subscribe(() => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      const state = store.getState();
      saveStateWithTimestamp(state);
    }, 1000); // Debounce saves by 1 second
  });
}

export default store;